import {
  PROMPT_CONTEXT_GROUPS,
  PromptContextName,
  PromptContextSubjectKind,
} from '@/types/prompts';

/**
 * Context Variables (spec FSI #1230): helpers over VH3's list as the lookup
 * returns it. The list itself lives in Xano (fn 2106); nothing here
 * hard-codes a name.
 */

/** The list by name, for quick checks. */
export const contextNamesByName = (names: PromptContextName[]) =>
  new Map(names.map(item => [item.name, item]));

/** Whether `{name}` is a Context Variable on the list. */
export const isContextName = (names: PromptContextName[], name: string) =>
  names.some(item => item.name === name);

/** A dotted name that is not on the list: refused on save. */
export const isUnknownDottedName = (names: PromptContextName[], name: string) =>
  name.includes('.') && !isContextName(names, name);

/** The list grouped for the Insert context menu, in the menu's order. */
export const contextNamesByGroup = (names: PromptContextName[]) =>
  PROMPT_CONTEXT_GROUPS.map(group => ({
    group,
    items: names.filter(item => item.group === group),
  })).filter(section => section.items.length > 0);

/** The fill step's quiet marker for a value found from the chat's subject. */
export const CONTEXT_MARKERS: Record<PromptContextSubjectKind, string> = {
  job: 'from Job',
  document: 'from document',
  quote: 'from quote',
};

/** The preview pane's "fills from …" line for a name, from its subjects. */
export const contextFillsFrom = (item: PromptContextName) => {
  if (item.subjects.includes('everywhere')) return 'fills in every chat';
  const parts = item.subjects.map(subject =>
    subject === 'job'
      ? 'the Job'
      : subject === 'document'
        ? 'the document'
        : 'the quote'
  );
  return `fills from ${parts.join(' or ')}`;
};
